export const BASIC_TEMP_JOB_POSTING_PRICE_FOR_MARKETING_ONLY = 94;
export const PREMIUM_TEMP_JOB_POSTING_PRICE_FOR_MARKETING_ONLY = 179;
export const BASIC_JOB_POSTING_PRICE_FOR_MARKETING_ONLY = 119;
export const PREMIUM_JOB_POSTING_PRICE_FOR_MARKETING_ONLY = 189;
export const NATIONAL_JOB_POSTING_PRICE_FOR_MARKETING_ONLY = 399;
export const BASIC_RESUME_SUBSCRIPTION_PRICE_FOR_MARKETING_ONLY = 179;
export const PREMIUM_RESUME_SUBSCRIPTION_PRICE_FOR_MARKETING_ONLY = 289;
export const SUPER_PREMIUM_PRICE_FOR_MARKETING_ONLY = 329;

export const STAFF_USER_COUNT_FOR_MARKETING_ONLY = `900,000`;
export const EMPLOYER_USER_COUNT_FOR_MARKETING_ONLY = `70,000`;

export const PASSWORD_MIN_LENGTH = 4; //Technically it's 8, but for backwards compatibility it's set to 4;
export const PASSWORD_MAX_LENGTH = 64;
export const NAME_MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 100;
export const EMPLOYER_NAME_MIN_LENGTH = 2;
export const EMPLOYER_NAME_MAX_LENGTH = 40;
export const PHONE_MIN_LENGTH = 10;
export const PHONE_MAX_LENGTH = 20;
export const SPECIALTY_MIN_LENGTH = 2;
export const SPECIALTY_MAX_LENGTH = 60;
export const EXPERIENCE_MAX_LENGTH = 60;
export const JOB_DESCRIPTION_MAX_LENGTH = 12000;
export const ALIGNMENT_MAX_LENGTH = 2000;
export const CLASSIFIED_ADDITIONAL_PHOTO_DESC_MAX_LENGTH = 256;
export const CERT_MAX_LENGTH = 80;
export const COMPANY_DESC_MAX_LENGTH = 305;
export const COURSE_DESC_MAX_LENGTH = 80;
export const COURSE_PROVIDER_MAX_LENGTH = 80;
export const COURSE_INSTRUCTOR_MAX_LENGTH = 80;
export const COURSE_REG_NUMBER_MAX_LENGTH = 45;
export const FEEDBACK_NOTE_MAX_LENGTH = 250;

export const MONDAY = 'monday';
export const TUESDAY = 'tuesday';
export const WEDNESDAY = 'wednesday';
export const THURSDAY = 'thursday';
export const FRIDAY = 'friday';
export const SATURDAY = 'saturday';
export const SUNDAY = 'sunday';

export const DISPLAY_MONDAY = 'Monday';
export const DISPLAY_TUESDAY = 'Tuesday';
export const DISPLAY_WEDNESDAY = 'Wednesday';
export const DISPLAY_THURSDAY = 'Thursday';
export const DISPLAY_FRIDAY = 'Friday';
export const DISPLAY_SATURDAY = 'Saturday';
export const DISPLAY_SUNDAY = 'Sunday';

export const DAYS = [
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
];

export const IDLE_STATUS = 'IDLE';
export const LOADING_STATUS = 'LOADING';
export const LOADING_MORE_STATUS = 'LOADING_MORE';
export const LOADED_STATUS = 'LOADED';
export const ERROR_STATUS = 'ERROR';
export const SUBMITTING_STATUS = 'SUBMITTING';

export const DRAFT_STATUS = 'DRAFT';
export const ACTIVE_STATUS = 'ACTIVE';
export const BOOKED_STATUS = 'BOOKED';
export const CANCELED_STATUS = 'CANCELED';

export const TEMP_JOB_TYPE = 'TEMP';
export const PERM_JOB_TYPE = 'PERM';
export const NAT_JOB_TYPE = 'NATIONAL';

export const MAP_VIEW = 'map';
export const LIST_VIEW = 'list';

export const NO_SHOW_BADGE = 'NOSHOW';
